// import React from "react";
// import { Form, DatePicker } from "antd";

// const CustomDateTimePicker = ({
//   label,
//   name,
//   defaultValue,
//   errorMessage,
//   required = false,
//   onChange,
//   showTime = true, // Enable/disable time picker
//   format = "YYYY-MM-DD hh:mm",
//   ...rest
// }) => {
//   return (
//     <Form.Item
//       label={label}
//       name={name}
//       initialValue={defaultValue}
//       rules={[{ required: required, message: `${label} is required` }]}
//       validateStatus={errorMessage ? "error" : ""}
//       help={errorMessage}
//       labelCol={{ span: 24 }}
//       wrapperCol={{ span: 24 }}
//       style={{ marginBottom: "0" }}
//     >
//       <DatePicker
//         showTime={showTime}
//         format={format}
//         onChange={onChange}
//         style={{ width: "100%" }}
//         {...rest}
//       />
//     </Form.Item>
//   );
// };

// export default CustomDateTimePicker;
import React from "react";
import { Form, DatePicker } from "antd";
import dayjs from "dayjs";

const CustomDateTimePicker = ({
  label,
  name,
  defaultValue,
  errorMessage,
  required = false,
  onChange,
  showTime = true, // Enable/disable time picker
  format = "YYYY-MM-DD HH:mm", // 24-hour format (HH instead of hh)
  picker,
  disabled,
  disableFuture = false, // New prop to control future date disabling
  disableCurrentMonth = false, // New prop to disable current month
  rules,
  ...rest
}) => {
  const disabledDate = (current) => {
    if (!disableFuture && !disableCurrentMonth) return false;

    const today = dayjs();

    if (picker === "month") {
      // For month picker - disable current and future months
      if (disableCurrentMonth && disableFuture) {
        return (
          current &&
          (current.isSame(today, "month") || current.isAfter(today, "month"))
        );
      } else if (disableFuture) {
        return current && current.isAfter(today, "month");
      } else if (disableCurrentMonth) {
        return current && current.isSame(today, "month");
      }
    } else {
      // For date picker - disable current and future dates
      if (disableCurrentMonth && disableFuture) {
        return (
          current &&
          (current.isSame(today, "day") || current.isAfter(today, "day"))
        );
      } else if (disableFuture) {
        return current && current.isAfter(today, "day");
      } else if (disableCurrentMonth) {
        return current && current.isSame(today, "day");
      }
    }

    return false;
  };
  // Merge required rule with custom rules
  const mergedRules = [
    ...(required ? [{ required: true, message: `${label} is required` }] : []),
    ...(Array.isArray(rules) ? rules : []),
  ];
  // console.log(rest.value);

  return (
    <Form.Item
      label={label}
      name={name}
      initialValue={defaultValue}
      rules={mergedRules}
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      style={{ marginBottom: "0" }}
    >
      <DatePicker
        showTime={picker ? null : { format: "HH:mm" }} // Ensures 24-hour format for time
        format={picker ? null : format}
        onChange={onChange}
        style={{ width: "100%" }}
        // value={""}
        disabled={disabled}
        picker={picker} // Allows for date or week picker
        disabledDate={disabledDate}
        {...rest}
      />
    </Form.Item>
  );
};

export default CustomDateTimePicker;
